import { render, staticRenderFns } from "./ThePisoSala.vue?vue&type=template&id=201392c8&scoped=true&"
import script from "./ThePisoSala.vue?vue&type=script&lang=js&"
export * from "./ThePisoSala.vue?vue&type=script&lang=js&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201392c8",
  null
  
)

export default component.exports